module.exports = __webpack_public_path__ + "img/Tablet - 66.bbbf6ed7.png";